export type ManualDAReceiptMethod = 'filename' | 'url';

const RECEIPT_URL_HOSTS = ['firebasestorage.googleapis.com', 'storage.googleapis.com'];

/**
 * Contrôle de saisie de la modale « Enregistrer une DA faite en externe ».
 * Mêmes règles que le serveur (`daManualReceiptController`) ; renvoie le
 * message à afficher, ou null si la saisie est exploitable.
 */
export const validateManualDAReceipt = (method: ManualDAReceiptMethod, rawValue: string): string | null => {
  const value = rawValue.trim();
  if (method === 'filename') {
    if (!value) return 'Veuillez entrer un nom de fichier';
    if (!value.startsWith('DA-')) return 'Le nom de fichier doit commencer par "DA-"';
    return null;
  }
  if (!value) return 'Veuillez entrer une URL Firebase';
  if (!RECEIPT_URL_HOSTS.some((host) => value.includes(host))) return "L'URL doit être une URL Firebase valide";
  if (!value.toLowerCase().includes('.pdf')) return "L'URL doit pointer vers un fichier PDF";
  return null;
};
